import FieldTypePill from "./FieldsFormulasConfiguration/FieldTypePill";

export function ChartTypePill({ isPositionDocument }: { isPositionDocument: boolean }) {
  return (
    <FieldTypePill
      type={isPositionDocument ? "position" : "employee"}
      pillProps={{
        size: "regular",
        className: "ocn-chart-type-pill"
      }}
    />
  );
}
